<template>
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1>Las Vegas</h1>
          <p>Under Construction</p>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>